export default function () {
	return { x: 0, y: 0 }
}
